import React from 'react';
import isNil from 'lodash-es/isNil';
import { gql } from '@yi/core';

import { graphql, useStaticQuery } from 'gatsby';
import { CourseCarousel } from '~/src/components/carousels/CourseCarousel';

import { sortCardsByIds } from '../sortCardsByIds';

interface Props {
  children: (data: React.ComponentProps<typeof CourseCarousel>['items']) => React.ReactNode;
}
const list = [
  // 1: Trauma Informed Yoga
  '4119637',
  // 2: Balancing the Chakras
  '1oCu7B8jVtvfIiE4iWMc9v',
  // 3: The Vagus Nerve and Yoga
  '4800386',
  // 4: Patanjali's Yoga Sutras
  '75nwuVMX5f7g5Lsi3ZXBdm',
  // 5: Exploring Yoga Anatomy
  '3356241',
  // 6: Foundations of Ayurveda
  '5607864',
  // 7: The Vital Psoas
  '4615502',
  // 8: Tantric Meditation
  '89GKaKnQMoZHRtAjgJbgP',
  // 9: Getting A Good Night's Sleep: An iRest Approach
  '5358658',
  // 10: What Every Yoga Teacher Needs to Know
  '3949070',
  // 11: Power of Mantra
  '6HvTjjsdm0zxOI7McvGOYN',
  // 12: Complete Pregnancy Program
  '3603652',
];

export const CoursesCarouselDataEN: React.FC<Props> = ({ children }) => {
  const yiData = useStaticQuery<gql.typesSsr.Query_AllCourses_LOH_EN>(graphql`
    query Query_AllCourses_LOH_EN {
      yi {
        allCourses(
          filter: {
            ids: [
              "4119637"
              "1oCu7B8jVtvfIiE4iWMc9v"
              "4800386"
              "75nwuVMX5f7g5Lsi3ZXBdm"
              "3356241"
              "5607864"
              "4615502"
              "89GKaKnQMoZHRtAjgJbgP"
              "5358658"
              "3949070"
              "6HvTjjsdm0zxOI7McvGOYN"
              "3603652"
            ]
          }
        ) {
          ...Fragment_CourseCard
        }
      }
    }
  `);

  const data = yiData?.yi?.allCourses;
  if (isNil(data)) {
    return null;
  }
  const sortedClassesData = sortCardsByIds(data, list);

  return <>{children(sortedClassesData)}</>;
};
